import * as angular from "angular";
import * as _ from "lodash";

import {IController, ITimeoutService} from "angular";
import {PlanningPanelModel} from "../../models/planning-panel.model";
import {PlanningViewSettingsResourcesModel} from "../../models/planning-view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {
  PlanningDraftResourcesSortingDialogComponent
} from "../../angular/components/planning-draft-resources-sorting-dialog/planning-draft-resources-sorting-dialog.component";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {
  PlanningResourcesHelperService,
  PlanningResourcesFilterContext
} from "../../services/planning-resources-helper.service";
import {PlanningViewMode} from "../../types/planning-view-mode.enum";

export class PlanningDraftResourcesPanelComponent implements IController {

  draft?: any;
  panels?: PlanningPanelModel[];
  panel?: PlanningPanelModel;
  selectedIds: string[];
  jobs: any[];
  selectedJobIds: string[];
  visibleRouteIds: string[];
  resources: any;
  routes: any;
  settings: PlanningViewSettingsResourcesModel;
  routesSettings: any;
  itemElementSize: string;
  onSettingsChange: Function;
  onSelect: Function;
  onAddToDraft: Function;
  onCreateRoute: Function;
  onRemove: Function;
  onEditResourceAllocation: Function;
  onChangeRouteResource: Function;
  onLockRouteChange: Function;
  onVisibleRoutesChange: Function;
  onPanelChange: Function;
  onDispatchRoutes: Function;
  onReoptimize: Function;
  onPrint: Function;
  onPrintLoadingSheet: Function;
  onChangeResourceSequence: Function;
  onDelete: Function;
  onDrillDown: Function;
  onUpdateRouteResource: Function;
  onOpenResourceInFloatingTable: Function;
  onDrilldownFloating: Function;
  viewMode: PlanningViewMode;

  public sortBy: string;
  public sortByType: any;
  public filteredResources: any;
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public selectedResource: any;
  public selectedResourceRoutes: any[];
  public routesMap: any = {};
  public planningViewMode: typeof PlanningViewMode = PlanningViewMode;
  public includeFilters: SiteFiltersType[] = [
    SiteFiltersType.branchIds,
    SiteFiltersType.labels,
    SiteFiltersType.vehicleTypes,
    SiteFiltersType.serviceAreaIds,
    SiteFiltersType.agentSkills,
    SiteFiltersType.inRoute
  ];
  public dropdownFilters: any;
  public pageName: string = 'planning-resources';

  /* @ngInject */
  constructor(private panelService: PanelService,
              private planningAlertsService: PlanningAlertsService,
              private $timeout: ITimeoutService,
              private planningResourcesHelperService: PlanningResourcesHelperService) {
  }

  $onInit() {
    if (!this.draft) {
      this.panel = {};
    }

    if (this.panel.selectedResourceId) {
      this.selectedResource = _.find(this.resources, {id: this.panel.selectedResourceId});
      this.updateSelectedResourceRoutes();
    }

    this.planningResourcesHelperService.initFilters(this.panel);
    this._setDropdownFilters();

    this.sortBy = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortBy || 'routesCount';
    this.sortByType = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortByType || 'desc';

    this._setFilteredResources();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.resources && !changes.resources.isFirstChange()) {
      this._setFilteredResources();
      if (this.panel?.selectedResourceId) {
        this.selectedResource = _.find(this.resources, {id: this.panel.selectedResourceId});
        this.updateSelectedResourceRoutes();
      }
    }
    if (changes.routes) {
      this._setFilteredResources();
      if (this.panel?.selectedResourceId) {
        this.selectedResource = _.find(this.resources, {id: this.panel.selectedResourceId});
        this.updateSelectedResourceRoutes();
      }
    }

    if (changes.panel && !changes.panel.isFirstChange()) {
      const currentPanel = changes.panel?.currentValue,
        previousPanel = changes.panel?.previousValue;

      this._setDropdownFilters();

      if (currentPanel.selectedResourceId !== previousPanel.selectedResourceId) {
        this.selectedResource = currentPanel.selectedResourceId ? _.find(this.resources, {id: currentPanel.selectedResourceId}) : undefined;
        this.updateSelectedResourceRoutes();
      }

      if ((currentPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortBy !== previousPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortBy) ||
        (currentPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortByType !== previousPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortByType)) {
        this.sortBy = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortBy;
        this.sortByType = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortByType;

        if (!!this.sortBy && !!this.sortByType) {
          this._sortFilteredResources();
        }
      }
    }
  }

  onBeforeEditResourceAllocation(resource: any, route: any, event: any) {
    this.onEditResourceAllocation({resource: resource, routeId: route?.id, event: event});
  }

  onQueryChanged(query) {
    this.panel.tabsFilterConfig[this.panel.selectedTabIndex].queryString = query;

    this._setFilteredResources();
    this.onPanelChange({panel: this.panel});
  }

  onFiltersChange(filters) {
    Object.assign(this.panel.tabsFilterConfig[this.panel.selectedTabIndex], _.pick(filters, this.includeFilters));

    this._setDropdownFilters();
    this._setFilteredResources();
    this.onPanelChange({panel: this.panel});
  }

  onToggleSort(event) {
    const panel = this.panelService.open(PlanningDraftResourcesSortingDialogComponent, event, {
      sortBy: this.sortBy,
      sortByType: this.sortByType,
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      width: 130,
      height: 205
    })

    if (panel) {
      panel.instance.onSortTypeChange.subscribe(data => {
        const panelCopy = angular.copy(this.panel);
        panelCopy.tabsFilterConfig[this.panel.selectedTabIndex].sortBy = data.sortBy;
        panelCopy.tabsFilterConfig[this.panel.selectedTabIndex].sortByType = data.sortByType;
        this.onPanelChange({panel: panelCopy});
      });
    }
  }

  onToggleAllResources() {
    const selectedIds: any[] = !this.selectedIds.length ?
      _.map(this.filteredResources, 'id')
      : [];
    this.onSelect({ids: selectedIds});
  }

  onDispatchResources(resourceIds: string[]) {
    const routesToDispatch = _.filter(this.routes, (r) => {
      return _.includes(resourceIds, r.resource?.id) && (r.status !== 'PARTIAL_DISPATCHED' && r.status !== 'DISPATCHED');
    })
    if (!routesToDispatch?.length) {
      this.planningAlertsService.noRoutesToDispatchInfo();
    } else {
      const routeIds = _.map(routesToDispatch, 'id');
      this.onDispatchRoutes({ids: routeIds});
    }
  }

  private _setDropdownFilters() {
    this.dropdownFilters = _.pick(this.panel.tabsFilterConfig[this.panel.selectedTabIndex], this.includeFilters);
  }

  private _setFilteredResources() {
    if (this.resources?.length !== this.filteredResources?.length) {
      this.filteredResources = undefined;
    }

    this._setRoutesMap();

    const resourcesCopy = this.planningResourcesHelperService.getEnrichedResources(this.resources, this.routesMap);

    const filterContext: PlanningResourcesFilterContext = {
      filterConfig: this.panel.tabsFilterConfig[this.panel.selectedTabIndex]
    };

    this.$timeout(0).then(() => {
      this.filteredResources = _.filter(resourcesCopy, (resource) => 
        this.planningResourcesHelperService.filterByFilters(resource, filterContext)
      );

      if (!!this.sortBy && !!this.sortByType) {
        this._sortFilteredResources();
      }
    })
  }

  private _sortFilteredResources() {
    this.filteredResources = this.planningResourcesHelperService.sortFilteredResources(this.filteredResources, this.sortBy, this.sortByType);
    this.$timeout(() => {}, 0);
  }

  onResourceDrilldown(resource, isFloating?: boolean) {
    if (isFloating && this.onOpenResourceInFloatingTable) {
      this.onOpenResourceInFloatingTable({resourceId: resource.id});
      return;
    }

    this.selectedResource = resource;
    this.updateSelectedResourceRoutes();

    const panelCopy = angular.copy(this.panel);
    panelCopy.selectedResourceId = resource.id;
    this.onPanelChange({panel: panelCopy});
  }

  onCloseResourceDrilldown() {
    this.selectedResource = undefined;
    this.selectedResourceRoutes = undefined;

    const panelCopy = angular.copy(this.panel);
    panelCopy.selectedResourceId = undefined;
    this.onPanelChange({panel: panelCopy});
  }

  onOpenRoute(event) {
    this.onDrillDown({routeId: event.routeId, event: event.event});
  }

  updateSelectedResourceRoutes() {
    if (this.selectedResource && this.routes) {
      this.selectedResourceRoutes = _.filter(this.routes, (r) => r.resourceId === this.selectedResource.id);
    } else {
      this.selectedResourceRoutes = [];
    }
  }

  private _setRoutesMap() {
    this.routesMap = this.planningResourcesHelperService.setRoutesMap(this.routes);
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftResourcesPanel', {
    bindings: {
      panels: '<',
      panel: '<',
      draft: '<',
      jobs: '<',
      selectedIds: '<',
      selectedJobIds: '<',
      visibleRouteIds: '<',
      resources: '<',
      routes: '<',
      settings: '<',
      routesSettings: '<',
      itemElementSize: '<?',
      viewMode: '<',
      onSettingsChange: '&',
      onRoutesSettingsChange: '&',
      onSelect: '&',
      onAddToDraft: '&',
      onCreateRoute: '&',
      onRemove: '&',
      onEditResourceAllocation: '&',
      onChangeRouteResource: '&',
      onLockRouteChange: '&',
      onVisibleRoutesChange: '&',
      onPanelChange: '&',
      onDispatchRoutes: '&',
      onReoptimize: '&',
      onPrint: '&',
      onPrintLoadingSheet: '&',
      onChangeResourceSequence: '&',
      onDelete: '&',
      onDrillDown: '&',
      onUpdateRouteResource: '&',
      onOpenResourceInFloatingTable: '&',
      onDrilldownFloating: '&'
    },
    template: require('./planning-draft-resources-panel.html').default,
    controller: PlanningDraftResourcesPanelComponent
  });
